import React from "react";
import Footer from "../../components/Footer";
import Criar from "../../components/Login/Criar";

export default function CriarConta() {
    return(
        <React.Fragment>
            <Criar/>
            <Footer/>
        </React.Fragment>
    )
}